import React from 'react';
import { Box, type SxProps, Typography } from '@mui/material';
import { format, isToday } from 'date-fns';

import DayNameTypography from './DayNameTypography';

interface CalendarDateHeaderProps {
  date: Date;
  sx?: SxProps;
}

const CalendarDateHeader = ({ date, sx = {} }: CalendarDateHeaderProps) => {
  const dayName = format(date, 'EEE');
  const dayNumber = format(date, 'd');
  const isTodayDate = isToday(date);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 0.5,
        p: 1.5,
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...sx,
      }}
    >
      <DayNameTypography>{dayName}</DayNameTypography>
      <Typography
        sx={{
          fontSize: '21px',
          fontWeight: isTodayDate ? 500 : 400,
          color: isTodayDate ? 'white' : '#535976',
          backgroundColor: isTodayDate ? 'primary.main' : 'transparent',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {dayNumber}
      </Typography>
    </Box>
  );
};

export default CalendarDateHeader;
